import { render } from "./EntitiesTable.vue?vue&type=template&id=a656a454"
import script from "./EntitiesTable.vue?vue&type=script&lang=js"
export * from "./EntitiesTable.vue?vue&type=script&lang=js"
script.render = render

export default script